module.exports = __webpack_public_path__ + "static/media/doulanshan_web.6f2d59e4.png";